export default __webpack_public_path__ + "static/media/consultant.3697260049e99736e73dca0413c2d4a5.svg";